import { useContext } from 'react';

import { Context } from '.';

export default function useFeatures() {
  return useContext(Context);
}
